export function ExclamationMark() {
  return (
    <svg width="4" height="29" viewBox="0 0 4 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="4" height="20" rx="2" fill="white" />
      <rect y="24.5" width="4" height="4" rx="2" fill="white" />
    </svg>
  );
}
